import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { isEmpty } from 'lodash-es';
import { getOrElse } from 'src/util/values';
import { Clipboard } from 'ts-clipboard';

type NewlineCharacter = 'lf' | 'crlf' | 'cf';
/*
const convertNewline: (
  newline: NewlineCharacter
) => { string: () => (value: string) => string } = require('convert-newline');
*/

@Injectable({
  providedIn: 'root',
})
export class ClipboardService {
  constructor(private _snackBar: MatSnackBar) {}

  public copy(
    text: string,
    {
      message,
      newline,
    }: {
      message?: string | false;
      newline?: NewlineCharacter | false;
    } = {},
  ) {
    message = getOrElse(message, 'Copied to clipboard');
    newline = getOrElse(newline, 'crlf');
    /*
    if (newline !== false) {
      // make newlines consistent so text will be more broadly compatible with other programs
      const converter = convertNewline(newline).string();
      text = converter(text);
    }*/

    Clipboard.copy(text);

    if (message !== false && !isEmpty(message)) {
      this._snackBar.open(message, undefined, {
        duration: 750,
      });
    }
  }
}
